export const styles = {
  header: {
    width: '100%',
  },
  iconRow: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    fontSize: '16px',
    lineHeight: '1',
    textAlign: 'center',
    color: '#6b7280',
    whiteSpace: 'nowrap',
  },
  icon: {
    objectFit: 'contain',
    flexShrink: 0,
    alignSelf: 'stretch',
    margin: 'auto 0',
    width: '24px',
    aspectRatio: '1',
  },
  iconText: {
    alignSelf: 'stretch',
    margin: 'auto 0',
    color: '#6b7280',
  },
  title: {
    marginTop: '20px',
    fontSize: '32px',
    fontWeight: 800,
    lineHeight: '1',
    color: '#0f172a',
    marginBottom: '-8px',
  },
  contentRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    alignSelf: 'stretch',
    width: '100%',
    fontSize: '16px',
    '@media (max-width: 768px)': {
      maxWidth: '100%',
    },
  },
  subtitle: {
    lineHeight: '1',
    color: '#0f172a',
    margin: 0,
  },
  navigation: {
    display: 'flex',
    gap: '20px',
    fontWeight: 700,
    lineHeight: '1',
    textAlign: 'center',
  },
  // Base styles shared by all nav buttons
  navButton: {
    transition: 'all 0.3s ease',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '8px 24px',
    borderRadius: '12px',
    border: '1px solid transparent',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 700,
    whiteSpace: 'nowrap',
    '& svg': {
      flexShrink: 0,
    },
    '@media (max-width: 768px)': {
      paddingLeft: '20px',
      paddingRight: '20px',
    },
  },
  // Upload button — outlined dark, fills red on hover
  uploadButton: {
    backgroundColor: 'transparent',
    borderColor: '#273754',
    color: '#273754',
    overflow: 'hidden',
    '&:hover': {
      backgroundColor: '#f8f9ff',
      borderColor: '#0f1729',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(26,37,71,.15)',
    },
    '&:active': {
      backgroundColor: '#f0f1ff',
      borderColor: '#0f1729',
      transform: 'translateY(0)',
      boxShadow: '0 2px 8px rgba(26,37,71,.1)',
    },
  },
  // Figma button — outlined dark, fills dark on hover, slightly lighter on active
  figmaButton: {
    backgroundColor: 'transparent',
    borderColor: '#1a2547',
    color: '#1a2547',
    '& svg path': {
      stroke: 'none !important',
    },
    '&:hover': {
      backgroundColor: '#1a2547',
      borderColor: '#1a2547',
      color: '#ffffff',
    },
    '&:active': {
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), #1a2547',
      borderColor: '#1a2547',
      color: '#ffffff',
    },
  },
  figmaIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // Design Tool button — filled red, lighter red on hover, slightly darker on active
  designToolButton: {
    backgroundColor: '#ee4360',
    borderColor: '#ee4360',
    color: '#ffffff',
    '& svg path': {
      fill: '#ffffff',
    },
    '&:hover': {
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), #ee4360',
      borderColor: 'transparent',
      color: '#ffffff',
    },
    '&:active': {
      background:
        'linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.05) 100%), #ee4360',
      borderColor: 'transparent',
      color: '#ffffff',
    },
  },
  uploadButtonText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    flex: 1,
    cursor: 'pointer',
  },
  // Keep for backwards compat (unused but avoids breaking other references)
  createButton: {
    border: 'none',
    background: 'none',
    padding: 0,
  },
  createButtonInner: {},
  createButtonInnerSecondary: {},
}
